<template>
  <div class="text">
    <div class="other_text_box">
      <div class="other_text_box_left">
        <i class="fa fa-smile-o" @click="emojiDialog = !emojiDialog"></i>
        <el-upload
          :show-file-list="false"
          :on-exceed="handleExceed"
          :before-upload="beforeAvatarUpload"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :action="getUploadImg + '?ts=' + Date.now()"
        >
          <i class="fa fa-picture-o"></i>
        </el-upload>
      </div>

      <VEmojiPicker @select="selectEmoji" v-if="emojiDialog"></VEmojiPicker>
      <el-button size="small" class="send_bt" @click="sendMessage"
        >Send(Enter)</el-button
      >
    </div>
    <textarea
      placeholder="Press Enter to Send Message"
      v-model="content"
      @keydown="onKeyup($event)"
    ></textarea>
    <!-- <div class="text_footer">
      <el-button size="small" class="send_bt" @click="sendMessage"
        >Send(Enter)</el-button
      >
    </div> -->
  </div>
</template>
<script>
// import { actions } from "../store";
import { VEmojiPicker } from "v-emoji-picker";
// import packData from "v-emoji-picker/data/emojis.json";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    VEmojiPicker,
  },
  computed: {
    ...mapState({
      //   xToken: (state) => state.app.token,
    }),
    ...mapGetters(["getUploadImg"]),
  },
  data() {
    return {
      content: "",
      // pack: packData,
      emojiDialog: false,
    };
  },
  methods: {
    selectEmoji(emoji) {
      this.content += emoji.data;
      this.emojiDialog = false;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isJPG && !isPNG) {
        this.$message.error(
          "The uploaded avatar image can only be in JPG or PNG format!"
        );
      }
      if (!isLt20M) {
        this.$message.error(
          "The size of the uploaded avatar image cannot exceed 20MB!"
        );
      }
      return (isJPG || isPNG) && isLt20M;
    },
    handleExceed(files, fileList) {
      this.$message.error("Only one picture can be uploaded!");
    },
    async handleUploadSuccess(res) {
      //获取上传图片地址
      if (res.status === "0") {
        this.sendImg(res.data);
        // this.$message.success("Image upload successfully!");
      } else {
        this.$message.error("Image upload failed, please upload again!");
      }
    },
    handleUploadError(err, file, fileList) {
      if (err) {
        this.$message.error(
          "There was an error uploading the image, please try again later！"
        );
      }
    },
    async onKeyup(e) {
      if (e.keyCode === 13 && this.content.length > 0) {
        e.preventDefault();
        let params = {
          content: this.content,
          text_type: 0,
        };
        await this.$store.dispatch("sendMessage", params).then((res) => {
          if (res.status !== "0") {
            this.$message({
              type: "warning",
              message: res.message,
            });
          } else {
            this.content = "";
          }
        });
      }
    },
    async sendImg(imgurl) {
      if (imgurl) {
        let params = {
          content: imgurl,
          text_type: 1,
        };
        await this.$store.dispatch("sendMessage", params).then((res) => {
          if (res.status !== "0") {
            this.$message({
              type: "warning",
              message: res.message,
            });
          } else {
            this.content = "";
          }
        });
      }
    },
    async sendMessage() {
      let params = {
        content: this.content,
        text_type: 0,
      };
      if (this.content.length > 0) {
        await this.$store.dispatch("sendMessage", params).then((res) => {
          if (res.status !== "0") {
            this.$message({
              type: "warning",
              message: res.message,
            });
          } else {
            this.content = "";
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  height: 250px;
  border-top: solid 1px #edecec;
  background-color: #fff;
  box-sizing: border-box;
  .emoji-picker {
    z-index: 9999 !important;
  }
  .other_text_box {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 1px rgb(237, 236, 236);
    padding: 0 10px 0 5px;
    box-sizing: border-box;
    i {
      font-size: 24px;
      color: #f48c06;
      margin: 0 5px !important;
      cursor: pointer;
    }
    .other_text_box_left {
      display: flex;
      justify-content: space-between;
    }
  }
  textarea {
    padding: 10px;
    height: calc(100% - 50px);
    // height: 100%;
    box-sizing: border-box;
    width: 100%;
    border: none;
    outline: none;
    font-family: "Micrsofot Yahei";
    resize: none;
  }
  .text_footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 50px;
    padding: 10px 10px;
    box-sizing: border-box;
    .el-button--mini:hover {
      background: #fdecd7;
      border-color: #fdecd7;
      color: #fff;
    }
    .send_bt {
      // padding: 5px 7px;
      box-sizing: border-box;
      margin-right: 10px;
      // background: #eee;
      outline: none;
    }
  }
}
</style>